import BaseCheckbox from 'components/atoms/base-checkbox';
import ButtonLoadingIcon from 'components/atoms/icons/buttonLoadingIcon';
import { useState } from 'react';
import { sleep } from 'utils';
import { useUpdateSmsPreferred } from 'infrastructure/hooks/ccm/console';

import s from './styles.module.scss';

import type { FC } from 'react';

interface TableCheckboxProps {
  patientGuid: string;
  actionType: 'removeFromQueue' | 'smsPreferred';
  defaultValue?: boolean;
  dataCy?: string;
  onClick?: () => void;
}

const TableCheckbox: FC<TableCheckboxProps> = ({
  patientGuid,
  defaultValue,
  dataCy,
  onClick,
  actionType,
}) => {
  const [checked, setChecked] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const { isLoading: smsLoading, updateSmsPreferred } = useUpdateSmsPreferred();

  const isLoading = actionType === 'smsPreferred' ? smsLoading : loading;

  const onChange = async (v: boolean) => {
    if (actionType === 'removeFromQueue') {
      setLoading(true);
      setChecked(v);

      await sleep(500);

      setLoading(false);
      onClick?.();
    }

    if (actionType === 'smsPreferred') {
      setChecked(v);
      updateSmsPreferred({ patientGuid, smsPreferred: v });
    }
  };

  return isLoading ? (
    <ButtonLoadingIcon className={s['spin-loading-icon']} />
  ) : (
    <BaseCheckbox value={checked} onChange={onChange} dataCy={dataCy} />
  );
};
export default TableCheckbox;
